export default {
      id: "icon-winter-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite.svg#icon-winter",
      toString: function () {
        return this.url;
      }
    }